import { useSettings } from "contexts/settings";
import { getPermissionName } from "shared/constants/permissions";

//TODO: Move permissions to src\contexts\permissions\use-has-permissions.js
export const useHasPermission = (permission, task, redoTask = "") => {
    const { hasPermission } = useSettings();
    const permissionName = getPermissionName(permission, task, redoTask);

    return permissionName ? hasPermission(permissionName) : false;
};
